import React from 'react';
import {Link} from 'react-router-dom'

function LogoImage(props) {
    return  <Link to={`${process.env.PUBLIC_URL}/`} >
                <img src={require(`../../assets/images/logo/${props.logo}`)} alt="App landing" className="img-fluid" />
            </Link>;
}

export default LogoImage;